/* CLVN scroll reveal.
   ──────────────────────────────────────────────────────────────────────────
   One observer for the whole page. Sections do not ship their own.

   The contract, which every clvn- section follows:

     <div data-reveal>                  up, the default
     <div data-reveal="fade">           opacity only
     <div data-reveal="scale">          settles in from slightly small
     <div data-reveal="up" style="--clvn-reveal-i: 2">   waits two steps

   Everything visual lives in clvn-base.css. This file only decides WHEN,
   never HOW, so changing the motion never means touching JavaScript.

   Three things it deliberately does not do:

   - It does not animate in the theme editor. A section that fades in while
     the merchant is editing it reads as a bug, and half the time they never
     scroll far enough to trigger it and report the section as blank.
   - It does not re-hide on the way out. Content that disappears when you
     scroll back up is the single most reported complaint about reveals.
   - It does not run at all under prefers-reduced-motion. The CSS already
     shows everything in that case, so there is nothing to wait for. */
(function () {
  var root = document.documentElement;

  // Set as early as this file runs. Until the class is on, clvn-base.css
  // keeps every [data-reveal] visible, so a blocked or failed script leaves
  // a readable page rather than an empty one.
  root.classList.add('clvn-js');

  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // document.body is null this early, so it cannot be read here. Shopify.designMode
  // is set by the editor before any of this runs and answers the same question.
  var editing = root.classList.contains('shopify-design-mode') ||
                (window.Shopify && window.Shopify.designMode);

  if (still || editing || !('IntersectionObserver' in window)) {
    root.classList.add('clvn-reveal-off');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, {
    // Fires a little before the element reaches the fold, so the motion has
    // finished by the time the reader's eye actually gets there.
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.01
  });

  function watch(scope) {
    (scope || document).querySelectorAll('[data-reveal], [data-text-reveal]').forEach(function (el) {
      if (el.dataset.clvnWatched) return;
      el.dataset.clvnWatched = '1';
      io.observe(el);
    });
  }

  // This file runs in the head, undeferred, so that html.clvn-js lands before
  // first paint. That means the body does not exist yet, and a querySelectorAll
  // here would quietly match nothing and leave every section hidden forever.
  // Setting the class is the only part that has to be early. Finding the
  // elements waits for the DOM.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(); });
  } else {
    watch();
  }

  // Shopify swaps section markup in place on every editor change and on some
  // storefront interactions. Anything that arrives later has to be picked up
  // or it stays hidden forever.
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
  document.addEventListener('clvn:reveal:scan', function (e) { watch(e.detail && e.detail.scope); });
})();
